export default __webpack_public_path__ + "static/media/sound.242173d9.svg";